import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SnackbarAlert from "../../common/sanckbar";
import { awsupload, get, patch, post } from "../../../utils/api";
import imageCompression from "browser-image-compression";

function EditProductCategoryDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState(false);
  const [alert_severity, setAlertSeverity] = useState("warning");
  const [alert_message, setMessage] = useState("");
  let [imageFile, setImagefile] = useState<any>();

  const [formData, setFormData] = useState({
    product_category: "",
    del: 0,
    image_id: "",
    image_url: "",
    status_id: 1,
    status: "active",
  });

  useEffect(() => {
    getProductCategoryDetail();

  }, []);

  const getProductCategoryDetail = async () => {
    try {
      const response = await get(`product_categories/${id}`, {});

      if (response) {
        console.log("ResponseNew", response);
         setFormData(response.data)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditProduct = async (e: any) => {
    e.preventDefault();
    console.log(e);

    let productCategoryDetails = {
      product_category: formData.product_category,
      image_id: formData.image_id,
      image_url: formData.image_url,
      del: formData.del,
      status_id: formData.status_id,
      status: formData.status,
    };

    try {
      const response = await patch(
        `product_categories/${id}`,
        productCategoryDetails
      );

      console.log(response.data);
      if (response) {
        alert("Product Category edited successfully", "success");
       // navigate("/product-categories/list");
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong", "warning");
    }
  };

  const handleChange = (e: any) => {
    setFormData({ ...formData, product_category: e.target.value });
  };

  

  const alert = (message: string, alert_severity: string) => {
    setSnackbar(true);
    setMessage(message);
    setAlertSeverity(alert_severity);
  };

  const closeSnackbar = () => {
    // this.setState({ snackbar: false });
    setSnackbar(false);
  };


  return (
    <>
      <SnackbarAlert
        open={snackbar}
        closeSnackbar={closeSnackbar}
        message={alert_message}
        severity={alert_severity}
      />

      <div
        className="container"
        style={{ marginTop: "22px", paddingLeft: "20px" }}
      >
        <div className="row new-client-header">
          <div className="col-xs-12">
            <h5>Edit Product Category</h5>
          </div>
        </div>
        <form onSubmit={handleEditProduct} style={{ maxWidth: "1152px" }}>
          <div className="row mt-3 mb-3">
            <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
              <label htmlFor="productCategory">Product Category</label>
            </div>
            <div className="col-xs-12 col-md-8 col-lg-8">
              <FormGroup>
                <TextField
                  sx={{ width: "100% !important" }}
                  fullWidth
                  required
                  id="productCategory"
                  className="reg-input name-field"
                  name="product_category"
                  value={formData.product_category}
                  onChange={handleChange}
                  // error={Boolean(errorState.first_name)}
                  // helperText={errorState.first_name}
                  placeholder="Product Category"
                ></TextField>
              </FormGroup>
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <Button
              variant="contained"
              type="submit"
              className="d-flex justify-content-end"
              style={{ marginBottom: "50px" }}
            >
              <span>Save</span>
            </Button>
          </div>
        </form>
      </div>
    </>
  );
}

export default EditProductCategoryDetails;
